import React from 'react';
import { useNavigate } from 'react-router-dom';

const ShippingPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="page-content">
      <div className="policy-page">
        <button 
          className="btn outline" 
          onClick={() => navigate(-1)}
          style={{ marginBottom: '2rem' }}
        >
          ← Back
        </button>
        
        <div className="policy-header">
          <h1 className="policy-title">🚚 Shipping Policy</h1>
          <p className="policy-date">Effective Date: January 14, 2025</p>
        </div>
        
        <div className="policy-content">
          <div className="policy-section">
            <p>At NeoTeeForge, we strive to deliver your orders as quickly and efficiently as possible. This policy outlines our shipping procedures for both digital and physical products.</p>
          </div>

          <div className="policy-section">
            <h3>📦 Digital Products (Instant Delivery)</h3>
            <p>All digital products including eBooks, PDFs, and digital downloads are delivered instantly after successful payment.</p>
            
            <h4>Delivery Method:</h4>
            <ul className="policy-list">
              <li><strong>Instant access</strong> in your account dashboard under "My Library"</li>
              <li>Download links sent to your registered email address</li>
              <li>Available for download for 30 days from purchase date</li>
              <li>Can be downloaded up to 3 times</li>
            </ul>
            
            <h4>What to do if you don't receive your digital product:</h4>
            <ol className="policy-list">
              <li>Check your spam/junk folder</li>
              <li>Verify your email address in your account settings</li>
              <li>Log into your account and check "My Library"</li>
              <li>Contact support@neoteeforge.com with your order number</li>
            </ol>
          </div>

          <div className="policy-section">
            <h3>📚 Physical Products (Books & Merchandise)</h3>
            <p>For physical products, here's what you can expect:</p>
            
            <h4>Processing Time:</h4>
            <ul className="policy-list">
              <li><strong>1-2 business days</strong> for order processing</li>
              <li>Orders placed after 2 PM IST are processed the next business day</li>
              <li>Weekends and holidays are not counted as business days</li>
              <li>Custom or personalized items may take 3-5 business days</li>
            </ul>
            
            <h4>Shipping Timelines:</h4>
            <div style={{ 
              background: '#f0f9ff', 
              padding: '1.5rem', 
              borderRadius: '12px',
              margin: '1rem 0'
            }}>
              <h4 style={{ color: '#0369a1', marginTop: 0 }}>Domestic Shipping (Within India):</h4>
              <ul className="policy-list">
                <li><strong>Standard Shipping:</strong> 5-7 business days</li>
                <li><strong>Express Shipping:</strong> 2-4 business days (additional charges apply)</li>
                <li>Major metros may receive deliveries faster</li>
              </ul>
              
              <h4 style={{ color: '#0369a1', marginTop: '1rem' }}>International Shipping:</h4>
              <ul className="policy-list">
                <li><strong>Standard International:</strong> 10-20 business days</li>
                <li><strong>Express International:</strong> 5-10 business days (additional charges apply)</li>
                <li>Delivery times vary by destination country</li>
              </ul>
            </div>
            
            <h4>Shipping Partners:</h4>
            <p>We work with trusted courier partners including:</p>
            <ul className="policy-list">
              <li>India Post</li>
              <li>Delhivery</li>
              <li>Blue Dart</li>
              <li>DTDC</li>
              <li>International: DHL, FedEx, UPS</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>📦 Order Tracking</h3>
            <ul className="policy-list">
              <li>Tracking details are emailed once your order is shipped</li>
              <li>You can also track orders from your account dashboard</li>
              <li>Tracking numbers are provided within 24 hours of dispatch</li>
              <li>Allow 12-24 hours for tracking information to update</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>📍 Shipping Address</h3>
            <p>Please ensure your shipping address is correct and complete:</p>
            <ul className="policy-list">
              <li>Full name (as per government ID)</li>
              <li>Complete address with landmark</li>
              <li>PIN code</li>
              <li>City and state</li>
              <li>Mobile number with country code</li>
            </ul>
            <p><strong>Important:</strong> We are not responsible for delays caused by incorrect addresses.</p>
          </div>

          <div className="policy-section">
            <h3>⚠️ Important Notes</h3>
            <div style={{ 
              background: '#fef3c7', 
              padding: '1rem', 
              borderRadius: '8px',
              borderLeft: '4px solid #d97706'
            }}>
              <p><strong>Please note that delays may occur due to:</strong></p>
              <ul className="policy-list">
                <li>Courier service delays</li>
                <li>Customs clearance (international orders)</li>
                <li>Weather conditions or natural disasters</li>
                <li>Public holidays or festivals</li>
                <li>COVID-19 related restrictions</li>
                <li>Remote or hard-to-reach locations</li>
              </ul>
              <p><strong>These delays are beyond our control.</strong></p>
            </div>
          </div>

          <div className="policy-section">
            <h3>🔄 Address Changes & Order Modifications</h3>
            <ul className="policy-list">
              <li>Address changes can be made within 12 hours of order placement</li>
              <li>Contact support immediately if you need to change your address</li>
              <li>Once shipped, address changes may not be possible</li>
              <li>Order cancellations are only possible before shipping</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>📦 Damaged or Lost Packages</h3>
            <p>If your package arrives damaged or is lost in transit:</p>
            <ol className="policy-list">
              <li>Contact us immediately at support@neoteeforge.com</li>
              <li>Provide photos of the damaged package/product</li>
              <li>Include your order number and tracking details</li>
              <li>We will work with the courier partner to resolve the issue</li>
              <li>Resolution may include replacement or refund</li>
            </ol>
          </div>

          <div className="policy-section">
            <h3>📞 Need Help?</h3>
            <div style={{ 
              background: '#f8fafc', 
              padding: '1.5rem', 
              borderRadius: '12px',
              marginTop: '1rem'
            }}>
              <p>For shipping-related inquiries:</p>
              <p><strong>📧 Email:</strong> support@neoteeforge.com</p>
              <p><strong>⏰ Response Time:</strong> Within 24 business hours</p>
              <p><strong>📋 Include in your email:</strong> Order number, product name, and issue description</p>
            </div>
          </div>

          <div style={{ 
            marginTop: '3rem', 
            paddingTop: '2rem', 
            borderTop: '1px solid #e2e8f0',
            background: '#f0fdf4',
            padding: '1.5rem',
            borderRadius: '12px'
          }}>
            <h4 style={{ color: '#059669', marginTop: 0 }}>💡 Pro Tips:</h4>
            <ul className="policy-list">
              <li>Order multiple items together to save on shipping</li>
              <li>Check for shipping promotions during festive seasons</li>
              <li>Follow us on social media for shipping discount codes</li>
              <li>Sign up for our newsletter to get notified about free shipping offers</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;